import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import {
  IFlightSearch,
  IMultiCityAirports,
} from "@/core/interfaces/IFlightSearch.interface";
import { AUTH_GETTERS } from "@/modules/Auth/vuex/getters";
import type { IFinancialProfile } from "@/core/interfaces/financialProfile.interface";
import UTILS from "@/core/utils";
import { USER_ROLES } from "@/core/enums/USER_ROLES";
import type { Organization } from "@/modules/Auth/types";

const getters: GetterTree<IFlightSearch, StoreState> = {
  isPolling: (state): boolean => state.isPolling,
  flightsResponse: (state) => state.flightsResponse,
  isFlightsLoading: (state): boolean => state.isFlightFetching,
  isAirportFetching: (state): boolean => state.isAirportFetching,
  loadingOriginAirports: (state): boolean => state.loadingOriginAirports,
  loadingDestinationAirports: (state): boolean =>
    state.loadingDestinationAirports,
  loadingFinancialProfiles: (state): boolean => state.loadingFinancialProfiles,
  airports: (state) => state.airports,
  originAirports: (state) => state.originAirports,
  destinationAirports: (state) => state.destinationAirports,
  searchFinancialProfiles: (state) => state.searchFinancialProfiles,
  enabledAirlines: (state) => state.enabledAirlines,
  getSelectedAirlines: (state) => state.selectedAirlines,
  getSelectedCurrencyCode: (state) => state.selectedCurrencyCode,
  flights: (state) => state.flights,
  filters: (state) => state.filters,
  currentJourneyLeg: (state) =>
    state.flightsResponse.journey_legs[state.currentLegIndex],
  nextJourneyLeg: (state) => state.flightsResponse.journey_legs[1],
  allJourneyLegs: (state) => state.flightsResponse.journey_legs,
  allSelectdFlightFilters: (state) => state.selectedFlightFilters,
  selectedAmountType: (state) => state.amountType,
  allSelectedFlightLegs: (state) => state.selectedFlightLegs,
  currentLegIndex: (state) => state.currentLegIndex,
  currentRouteType: (state) => state.route_type,
  getMulticityLegs: (state) => state.multiCityLegs,

  journeyLegs: (state) => state.flightsResponse.journey_legs,

  sabreAirlines: (state): IFlightSearch["sabreAirlines"] => state.sabreAirlines,
  galileoAirline: (state): IFlightSearch["galileoAirline"] =>
    state.galileoAirline,
  multiCityAirports: (state): IMultiCityAirports[] => state.multiCityAirports,
  flightProviders: (state): IFlightSearch["flightProviders"] =>
    state.flightProviders,
  multicityInputLoadingType: (state): string | null =>
    state.currentMultiCityAirportInputTypeLoading,
  multicityInputLoadingIndex: (state): number | null =>
    state.currentMultiCityAirportInputIndexLoading,
  currencyCodes: (state): string[] | null => state.currencyCodes,
  selectedFinancialProfile: (state): string => state.selectedFinancialProfile,
  selectedSearchOrganizationId: (
    state,
    _getters,
    _rootState,
    rootGetters,
  ): string => {
    const isSuperUserOrOperationUser =
      UTILS.isUser(USER_ROLES.SUPER_USER) ||
      UTILS.isUser(USER_ROLES.OPERATIONS);

    if (isSuperUserOrOperationUser) {
      const profiles = state.searchFinancialProfiles as
        IFinancialProfile[] | null;
      const selectedFp = profiles?.find(
        (fp) => fp.public_id === state.selectedFinancialProfile,
      );
      return selectedFp?.organization_public_id || "";
    }

    const organization = rootGetters[
      AUTH_GETTERS.ORGANIZATION
    ] as Organization | null;
    return organization?.organization_id || "";
  },
};

export default getters;
